import Users from "./Users";

export default class Bookings {
    id: number
    eventId: number
    bookingResponsibleUserId: number
    creatorUserId: number
    bookingDate: Date
    paymentTypeId: number
    paymentStatusId: number
    paymentDate: Date
    bookingTotal: number
    bookingAlternativePrice: number
    bookingResponsibleUser: Users
    membersCount: number
    paymentStatusName: string
    isValid: boolean
    paymentTypeName: string
    [key: string]: any
}